module.exports = __webpack_public_path__ + "media/images/element/medal-badge-e5d902f97736b9c6df9f56e324260af7.png";